export const INTERSECTIONS_REPORT_ADDITIONAL_FILEDS = 'intersectionsReportAdditionalFields';
